import { CookieService } from 'ngx-cookie';
import { ErrorHandler, Injectable, NgZone, Injector, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Injectable()
export class ApplicationErrorHandler extends ErrorHandler {
    private zone = inject(NgZone);
    private injector = inject(Injector);


    handleError(errorResponse: HttpErrorResponse | any) {
        const cookie = this.injector.get(CookieService);
        const accessToken = cookie.get(environment.oab_access_token);
        if (!accessToken) {
            this.injector.get(Router).navigate(['/pages/login']);
        } else {
            if (errorResponse instanceof HttpErrorResponse) {
                const toastr = this.injector.get(ToastrService);
                this.zone.run(() => {
                    switch (errorResponse.status) {
                        case 401:
                            // this.injector.get(Router).navigate(['/pages/login']);
                            break;
                        case 403:
                            this.injector.get(Router).navigate(['/pages/not-authorized']);
                            break;
                    }
                });
            }
        }

        super.handleError(errorResponse);
    }

}
